/* PRA Cosmetics - cinematic scroll reveals. Progressive enhancement:
   content is fully visible by default; this only runs when motion is
   allowed AND IntersectionObserver exists, and reveals on scroll with a
   safety net so nothing can ship blank. */
(function () {
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if ((mq && mq.matches) || !('IntersectionObserver' in window)) return;

  function init() {
    var st = document.createElement('style');
    st.id = 'pra-motion-style';
    st.textContent =
      '.pra-reveal{opacity:0;transform:translateY(26px);' +
      'transition:opacity .8s cubic-bezier(.22,.61,.36,1),transform .8s cubic-bezier(.22,.61,.36,1);}' +
      '.pra-reveal.is-in{opacity:1;transform:none;}';
    document.head.appendChild(st);

    var sel = [
      '.pra-pcards__title', '.pra-pcards__sub',
      '.pra-pcards__grid > .pra-pcard',
      '.pra-cats > .pra-cat',
      '.pra-spot__title', '.pra-spot__media', '.pra-spot__more',
      '.pra-spot__cards > .pra-pcard',
      '.pra-tt__title', '.pra-tt__grid > .pra-tt__card',
      '.pra-stmt__inner',
      '.pra-guarantee',
      '[id*="__videos"] h2', '[id*="__videos"] iframe'
    ].join(', ');

    var els = [].slice.call(document.querySelectorAll(sel));
    if (!els.length) return;

    // stagger siblings within the same parent for a cascade
    var counters = (typeof Map !== 'undefined') ? new Map() : null;
    var fallbackKeyAttr = 'data-pra-grp';
    var grp = 0;
    els.forEach(function (el) {
      var p = el.parentNode, i;
      if (counters) { i = counters.get(p) || 0; counters.set(p, i + 1); }
      else {
        if (!p.getAttribute(fallbackKeyAttr)) { p.setAttribute(fallbackKeyAttr, ++grp); p._praN = 0; }
        i = p._praN++;
      }
      el.classList.add('pra-reveal');
      el.style.transitionDelay = Math.min(i, 5) * 80 + 'ms';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });

    // safety: never leave content hidden (headless / no-scroll / observer miss)
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }, 2800);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
